import { render, staticRenderFns } from "./GeneratedReward.vue?vue&type=template&id=77628666&"
import script from "./GeneratedReward.vue?vue&type=script&lang=js&"
export * from "./GeneratedReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports